import { FormlyFieldConfig } from 'ng-formly';
export const dataelementFields: Array<FormlyFieldConfig> = [
    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-3',
        templateOptions: {
            type: 'text',
            placeholder: 'Name',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'group',
        type: 'input-field',
        className: 'col-md-2',
        templateOptions: {
            type: 'text',
            placeholder: 'Dataelement Group Name',
            required: true,
            label: 'Group Name'
        }
    },
    {
        key: 'description',
        type: 'input-field',
        className: 'col-md-7',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'developmentpriority',
        type: 'input-field',
        className: 'col-md-2',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Development Priority'
        }
    },
    {
        key: 'developmentstatus',
        type: 'select-component',
        className: 'col-md-2',
        defaultValue: 'Yet to Start',
        templateOptions: {
            options: [{
                label: 'Yet to Start',
                value: 'Yet to Start'
            }, {
                label: 'Work in Progress',
                value: 'Work in Progress'
            }, {
                label: 'Completed',
                value: 'Completed'
            }, {
                label: 'Approved',
                value: 'Approved'
            }],
            label: 'Development Status',
            required: true,
            placeholder: ''
        }
    },
    {
        key: 'developmentnotes',
        type: 'input-field',
        className: 'col-md-8',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Development Team Notes'
        }
    },
    {
        type: 'repeatedsection',
        className: 'col-md-12',
        key: 'queries',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Query'
            },
            fieldGroup: [
                {
                    key: 'querytype',
                    type: 'select-component',
                    className: 'col-md-4',
                    templateOptions: {
                        options:
                        [{
                            label: 'Aggregation',
                            value: 'aggregate'
                        },
                        {
                            label: 'FindOne Query',
                            value: 'findOne'
                        },
                        {
                            label: 'Find All Query',
                            value: 'find'
                        }],
                        label: 'Query Type',
                        required: true,
                        placeholder: 'Select Query Type'
                    }
                },
                {
                    key: 'collection',
                    type: 'select-component',
                    className: 'col-md-4',
                    templateOptions: {
                        options:
                        [{
                            label: 'Entity Record',
                            value: 'entityrecord'
                        },
                        {
                            label: 'Aggregates',
                            value: 'aggregates'
                        },
                        {
                            label: 'Activities',
                            value: 'activity'
                        },
                        {
                            label: 'Time Series',
                            value: 'timeseries'
                        },
                        {
                            label: 'Elasticsearch',
                            value: 'elasticsearch'
                        }],
                        label: 'Collection',
                        required: true,
                        placeholder: 'Select Collection'
                    }
                },
                {
                    className: 'col-md-12',
                    template: '<hr>',
                },
                {
                    className: 'col-md-6',
                    type: 'textarea-field',
                    key: 'query',
                    templateOptions: {
                        label: 'Query JSON (Please Minify the JSON before Pasting here)',
                        required: true,
                        rows: 20
                    },
                },
                {
                    className: 'col-md-6',
                    type: 'textarea-field',
                    key: 'mongoquery',
                    templateOptions: {
                        label: 'MongoBooster Query As Is (Please Minify the Content before Pasting here)',
                        required: true,
                        rows: 20
                    }
                }
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'testvalues',
        className: 'col-md-12',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Test Fields for Query - Will replace "%key%" as "value"'
            },
            fieldGroup: [
                {
                    className: 'col-md-4',
                    type: 'input-field',
                    key: 'key',
                    templateOptions: {
                        type: 'text',
                        label: 'Key',
                        required: true,
                    },
                },
                {
                    className: 'col-md-4',
                    type: 'input-field',
                    key: 'value',
                    templateOptions: {
                        type: 'text',
                        label: 'Value',
                        required: true,
                    }
                }
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'fields',
        className: 'col-md-12',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Output Fields'
            },
            fieldGroup: [
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'name',
                    templateOptions: {
                        type: 'text',
                        label: 'Name',
                        required: true,
                    },
                },
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'label',
                    templateOptions: {
                        type: 'text',
                        label: 'Label',
                        required: true,
                    },
                },
                {
                    key: 'fieldtype',
                    type: 'select-component',
                    className: 'col-md-2',
                    templateOptions: {
                        options: [{
                            label: 'Currency',
                            value: 'currency'
                        }, {
                            label: 'Date',
                            value: 'date'
                        }, {
                            label: 'Date & Time',
                            value: 'dateandtime'
                        }, {
                            label: 'Time',
                            value: 'time'
                        }, {
                            label: 'Email',
                            value: 'email'
                        }, {
                            label: 'Geolocation',
                            value: 'geolocation'
                        }, {
                            label: 'Number',
                            value: 'number'
                        }, {
                            label: 'Percent',
                            value: 'percent'
                        }, {
                            label: 'PickList',
                            value: 'picklist'
                        }, {
                            label: 'Phone',
                            value: 'phone'
                        }, {
                            label: 'Text',
                            value: 'text'
                        }, {
                            label: 'URL',
                            value: 'url'
                        }],
                        label: 'Field Type',
                        required: true,
                        placeholder: 'Select Fieldtype'
                    }
                },
                {
                    className: 'col-md-2',
                    type: 'picklist-select',
                    key: 'picklistfield',
                    hideExpression: '(model.fieldtype !== "picklist")',
                    templateOptions: {
                        label: 'Picklist',
                        required: false,
                    }
                },
                {
                    className: 'col-md-2',
                    type: 'input-field',
                    key: 'unit',
                    templateOptions: {
                        type: 'text',
                        label: 'Unit',
                        required: false,
                    }
                }
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'filterfields',
        className: 'col-md-12',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Filter Fields'
            },
            fieldGroup: [
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'name',
                    templateOptions: {
                        type: 'text',
                        label: 'Field name',
                        required: true,
                    },
                },
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'label',
                    templateOptions: {
                        type: 'text',
                        label: 'Label of the field',
                        required: true,
                    },
                },
                {
                    key: 'fieldtype',
                    type: 'select-component',
                    className: 'col-md-3',
                    templateOptions: {
                        options: [{
                            label: 'Currency',
                            value: 'currency'
                        }, {
                            label: 'Date',
                            value: 'date'
                        }, {
                            label: 'Date & Time',
                            value: 'dateandtime'
                        }, {
                            label: 'Time',
                            value: 'time'
                        }, {
                            label: 'Email',
                            value: 'email'
                        }, {
                            label: 'Geolocation',
                            value: 'geolocation'
                        }, {
                            label: 'Number',
                            value: 'number'
                        }, {
                            label: 'Percent',
                            value: 'percent'
                        }, {
                            label: 'Phone',
                            value: 'phone'
                        }, {
                            label: 'Text',
                            value: 'text'
                        }, {
                            label: 'URL',
                            value: 'url'
                        }],
                        label: 'Field Type',
                        required: true,
                        placeholder: 'Select Fieldtype'
                    }
                },
                {
                    className: 'col-md-3',
                    type: 'select-component',
                    key: 'inputtype',
                    templateOptions: {
                        label: 'Input Type',
                        description: 'Type of input acceptance for the field',
                        required: true,
                        options: [
                            { label: 'Input', value: 'input' },
                            { label: 'Lookup', value: 'lookup' },
                            { label: 'Picklist', value: 'picklist' }
                        ]
                    },
                    lifecycle: {
                        onChanges: (form, field, model, options) => {
                            console.log('onchanges:- form:-', form, ' model:- ', model, ' field:-', field);
                        }
                    }
                },
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'relateduid',
                    hideExpression: '(!model.inputtype || model.inputtype === "input")',
                    templateOptions: {
                        type: 'text',
                        label: 'Entity Type Id',
                        required: false
                    },
                    expressionProperties: {
                        'templateOptions.required': '(model.inputtype !== "input") ? true : false',
                        'templateOptions.label': '(model.inputtype === "picklist") ? "PickList Id" : "Entity Type Id"'
                    }
                },
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'relatedentityname',
                    hideExpression: '(!model.inputtype || model.inputtype !== "lookup")',
                    templateOptions: {
                        type: 'text',
                        label: 'Related Entity Name',
                        required: false
                    },
                    expressionProperties: {
                        'templateOptions.required': '(model.inputtype === "lookup") ? true : false'
                    }
                }
            ]
        }
    },
    {
        key: 'columndefinition',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Custom Column Definition for Tables (Please Minify the Content before Pasting here)',
            description: 'Provide the custom column definition for tables here',
            rows: 10
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },
    {
        className: 'col-md-12',
        templateOptions: {
            label: 'Chart'
        },
        fieldGroup: [
            {
                key: 'seriestype',
                type: 'select-component',
                className: 'col-md-4',
                templateOptions: {
                    options: [{
                        label: 'Single',
                        value: 'single'
                    }, {
                        label: 'Multi',
                        value: 'multi'
                    }],
                    label: 'Chart Series Type',
                    required: false,
                    placeholder: 'Select Type'
                }
            },
            {
                className: 'col-md-12',
                template: '<hr>',
            },
            {
                className: 'col-md-4',
                type: 'input-field',
                key: 'x-axis-label',
                templateOptions: {
                    type: 'text',
                    label: 'X-Axis Label',
                    required: false,
                },
            },
            {
                key: 'x-axis-fieldtype',
                type: 'select-component',
                className: 'col-md-4',
                templateOptions: {
                    options: [{
                        label: 'Currency',
                        value: 'currency'
                    }, {
                        label: 'Date',
                        value: 'date'
                    }, {
                        label: 'Date & Time',
                        value: 'dateandtime'
                    }, {
                        label: 'Time',
                        value: 'time'
                    }, {
                        label: 'Email',
                        value: 'email'
                    }, {
                        label: 'Geolocation',
                        value: 'geolocation'
                    }, {
                        label: 'Number',
                        value: 'number'
                    }, {
                        label: 'Percent',
                        value: 'percent'
                    }, {
                        label: 'Phone',
                        value: 'phone'
                    }, {
                        label: 'Text',
                        value: 'text'
                    }, {
                        label: 'URL',
                        value: 'url'
                    }],
                    label: 'X-Axis Field Type',
                    required: true,
                    placeholder: 'Select Fieldtype'
                }
            },
            {
                key: 'x-axis-dateformat',
                type: 'select-component',
                className: 'col-md-4',
                templateOptions: {
                    options: [{
                        label: 'YYYY-MM-DD',
                        value: 'YYYY-MM-DD'
                    }, {
                        label: 'DD-MM-YYYY',
                        value: 'DD-MM-YYYY'
                    }],
                    label: 'X-Axis Date Format',
                    required: true,
                    placeholder: 'Select Date Format'
                }
            },
            {
                className: 'col-md-4',
                type: 'input-field',
                key: 'y-axis-label',
                templateOptions: {
                    type: 'text',
                    label: 'Y-Axis Label',
                    required: false,
                },
            },
            {
                key: 'y-axis-fieldtype',
                type: 'select-component',
                className: 'col-md-4',
                templateOptions: {
                    options: [{
                        label: 'Currency',
                        value: 'currency'
                    }, {
                        label: 'Date',
                        value: 'date'
                    }, {
                        label: 'Date & Time',
                        value: 'dateandtime'
                    }, {
                        label: 'Time',
                        value: 'time'
                    }, {
                        label: 'Email',
                        value: 'email'
                    }, {
                        label: 'Geolocation',
                        value: 'geolocation'
                    }, {
                        label: 'Number',
                        value: 'number'
                    }, {
                        label: 'Percent',
                        value: 'percent'
                    }, {
                        label: 'Phone',
                        value: 'phone'
                    }, {
                        label: 'Text',
                        value: 'text'
                    }, {
                        label: 'URL',
                        value: 'url'
                    }],
                    label: 'Y-axis Field Type',
                    required: true,
                    placeholder: 'Select Fieldtype'
                }
            },
            {
                key: 'y-axis-dateformat',
                type: 'select-component',
                className: 'col-md-4',
                templateOptions: {
                    options: [{
                        label: 'YYYY-MM-DD',
                        value: 'YYYY-MM-DD'
                    }, {
                        label: 'DD-MM-YYYY',
                        value: 'DD-MM-YYYY'
                    }],
                    label: 'Y-Axis Date Format',
                    required: true,
                    placeholder: 'Select Date Format'
                }
            }
        ]
    }

];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/dataelement.ts